var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 359 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35348 11.6465C7.54874 11.4513 7.54874 11.1347 7.35348 10.9394L1.93233 5.51826C1.73706 5.323 1.42048 5.323 1.22522 5.51826C1.02996 5.71353 1.02996 6.03011 1.22522 6.22537L6.64637 11.6465C6.84163 11.8418 7.15822 11.8418 7.35348 11.6465Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 360 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64645 11.6464C6.84171 11.8417 7.15829 11.8417 7.35355 11.6464L12.7747 6.22529C12.97 6.03003 12.97 5.71345 12.7747 5.51819C12.5794 5.32293 12.2629 5.32293 12.0676 5.51819L6.64645 10.9393C6.45118 11.1346 6.45118 11.4512 6.64645 11.6464Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9886dca58f17d8df1d07c21834e32981.svg";
export { ForwardRef as ReactComponent };